import axios from 'axios';

import store from '@/store/index.js'

const service = axios.create({
  timeout: 30 * 1000
})

service.interceptors.request.use(config => {
  config.headers["Authorization"] = store.getters.ai_token
  config.headers["Content-Type"] = "application/json"

  return config
}, error => {
  return Promise.reject(error)
})

service.interceptors.response.use(res => {
  const data = res.data
  const code = data.code

  if (code === 0) {
    return res
  } else {
    return Promise.reject(data.msg)
  }
}, err => {
  return Promise.reject(err)
})


export function getOnlineInfo(data) {
  return service.get("https://api.coze.cn/v1/bot/get_online_info", { params: data })
}

export function getConversations(data) {
  return service.get("https://api.coze.cn/v1/conversations", { params: data })
}

export function createConversation(data) {
  return service.post("https://api.coze.cn/v1/conversation/create", data)
}

export function getMessageList(data, params) {
  return service.post("https://api.coze.cn/v1/conversation/message/list", data, { params })
}


